// extracted by mini-css-extract-plugin
export default {"wrap":"Trainings_wrap__NaHAa","selectedDate":"Trainings_selectedDate__JeLD2"};